import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import {PartnerSelect} from "../../../utils/formatters";

class tradenameForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput
                            name="name"
                            value={this.props.values.name}
                            label="Név"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("name")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Select
                            objectValue={true}
                            name="partner"
                            value={this.props.values.partner}
                            labelKey="name"
                            valueKey="partner_id"
                            component="partner"
                            optionsTemplate={PartnerSelect}
                            storeType="remote"
                            saveChanges={this.props.setFieldValue}
                            label="Partner"
                            {...this.props.getFieldProps("partner")}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(tradenameForm);
